
import React, { useState, useRef, useEffect } from 'react';
import { ChromePicker } from 'react-color';

export const hexToRgba = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  return {
    r: (bigint >> 24) & 255,
    g: (bigint >> 16) & 255,
    b: (bigint >> 8) & 255,
    a: (bigint & 255) / 255
  };
};

export const rgbaToHex = (rgba) => {
  return "#" + [rgba.r, rgba.g, rgba.b, Math.round(rgba.a * 255)]
    .map(val => val.toString(16).padStart(2, "0"))
    .join("");
};


const ColorMap = ({colormap, handleColorChange, isHex}) => {
  return (
    <div className='colormap'>
      {Object.entries(colormap).map(([key, color], index) => {
        return (
          <div key={key} className={`color-entry column-${index % 3}`}>
            <span>{key}:</span>
            <ColorBox 
              colorHex={isHex ? color : rgbaToHex(color)} 
              onColorChange={(newHex) => handleColorChange(key, newHex)}
            />
          </div>
        );
      })}
    </div>
  )
}

export const ColorBox = ({ colorHex, onColorChange }) => {
  const [showPicker, setShowPicker] = useState(false);

  const currentColor = hexToRgba(colorHex);
  const pickerRef = useRef(null);
  const colorBoxRef = useRef(null);
  
  const handleClickOutside = (event) => {
    if (pickerRef.current && (pickerRef.current.contains(event.target) || event.target === colorBoxRef.current)) {
        return; // Do nothing if the color box or picker is clicked
    }
    setShowPicker(false);
  };

  useEffect(() => {
    if (showPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPicker]);

  return (
    <div style={{ position: 'relative' }}>
      <div 
        style={{
          width: '24px',
          height: '24px',
          borderRadius: '4px',
          background: `rgba(${currentColor.r}, ${currentColor.g}, ${currentColor.b}, ${currentColor.a})`,
          cursor: 'pointer',
          border: '.1px solid #AAA'
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
          setShowPicker(!showPicker);
        }}
      />
      {showPicker && (
        <div ref={pickerRef} style={{ position: 'absolute', zIndex: 10, top: '30px' }}>
          <ChromePicker 
            color={currentColor}
            onChange={(colorResult) => {
              onColorChange(rgbaToHex(colorResult.rgb));
            }}
          />
        </div>
      )}
    </div>
  );
};


export const colorsTurbo = (range) => {
  const rescale = (value, [min, max]) => {
    return min + (value * (max - min));
  };

  const turbo = [ 
    0.0, '#30123b',
    0.071, '#4145ab',
    0.143, '#4675ed',
    0.214, '#39a2fc',
    0.286, '#1bcfd4',
    0.357, '#24eca6',
    0.429, '#61fc6c',
    0.5, '#a4fc3b',
    0.571, '#d1e834',
    0.643, '#f3c63a',
    0.714, '#fe9b2d',
    0.786, '#f36315',
    0.857, '#d93806',
    0.929, '#b11901',
    1.0, '#7a0402'
  ];
  return turbo.map((item, index) => {
    if (index % 2 === 0) {
      return rescale(item, range);
    }
    return item;
  });
}
export default ColorMap;

